import React from "react";
import { spacing } from "../../../stitches.config";
import { Button } from "../../Common/Buttons/Button";
import { FlexRow } from "../__styles__/Layout";
import { ButtonLink } from "../ButtonLink";

const WizardActionButtons = ({
  disablePrimary,
  isPrimaryButtonLoading,
  onBackClick,
  onCancelClick,
  onPrimaryButtonClick,
  primaryButtonText,
  showBackButton,
}: {
  disablePrimary: boolean;
  isPrimaryButtonLoading: boolean;
  onBackClick: () => void;
  onCancelClick: () => void;
  onPrimaryButtonClick: () => void;
  primaryButtonText: string;
  showBackButton: boolean;
}) => {
  return (
    <FlexRow style={{ gap: spacing.m.value }}>
      {showBackButton && (
        <ButtonLink onClick={onBackClick} styleVariant="primary" size="small">
          Back
        </ButtonLink>
      )}
      <Button
        size="small"
        variant="outline"
        onPress={onCancelClick}
        title="Cancel"
      />
      <Button
        size="small"
        variant="primary"
        onPress={onPrimaryButtonClick}
        isDisabled={disablePrimary}
        isPending={isPrimaryButtonLoading}
        title={primaryButtonText}
      />
    </FlexRow>
  );
};

export default WizardActionButtons;
